import React, { useEffect, useMemo } from "react";
import { NavLink, Outlet, Route, Routes, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import _ from 'lodash';

import Text from "src/components/text";
import Thumbnail from "src/components/thumbnail";

import { ExploreCoaching } from "./explore";
import { StudioPage } from "./studio";
import { Learnings } from "./learnings";
import { ManageCoursesPage } from "./manage";
import { CoachingReports } from "./reports";

import { EditCoursePage } from "./manage/courses/edit";
import { EditCourseStructurePage } from "./manage/courses/edit/structure";

import { ViewCoursePage, ViewCourseStructurePage } from "./learnings/course/view";
import { ViewExploreCoursePage } from "./explore/course/view";  
import { ViewExploreSimulationPage } from "./explore/simulation/view";
import { PreviewCoursePage, PreviewCourseStructurePage } from "./manage/courses/preview";
import { EditSimulationPage } from "./manage/simulations/edit";
import { ViewSimulationPage } from "./learnings/simulation/view";

import { PreviewSimulationPage } from "./manage/simulations/preview";
import { EditPodcastPage } from "./manage/podcasts/edit";

import { ViewPodcastPage } from "./learnings/podcast/view";

import { ViewDemoCoursePage, ViewDemoCourseStructurePage } from "./demo/courses";
import { ViewDemoSimulationPage } from "./demo/simulations";

import userRoleService from "src/services/userRoles.service";
import { getFullName } from "src/services/utils";

import styles from "./coaching.module.scss";
import { ViewExplorePodcastPage } from "./explore/podcast/view";

const CoachingPage: React.FC<object> = () => {
  return (
    <Routes>
      <Route path="/" element={<CoachingLayoutPage />}>
        <Route path="/explore" Component={ExploreCoaching}></Route>
        <Route path="/studio" Component={StudioPage}></Route>
        <Route path="/courses" Component={Learnings}></Route>
        <Route path="/manage" Component={ManageCoursesPage}></Route>
        <Route path="/reports" Component={CoachingReports}></Route>
      </Route>
      <Route path="/manage/courses/draft/:id" Component={EditCoursePage}></Route>
      <Route path="/manage/courses/draft/:id/contents" Component={EditCourseStructurePage}></Route>

      <Route path="/manage/courses/preview/:id" Component={PreviewCoursePage}></Route>
      <Route path="/manage/courses/preview/:id/contents" Component={PreviewCourseStructurePage}></Route>

      <Route path="/courses/:courseId" Component={ViewCoursePage}></Route>
      <Route path="/courses/:id/contents" Component={ViewCourseStructurePage}></Route>

      <Route path="/manage/simulations/draft/:id" Component={EditSimulationPage}></Route>
      <Route path="/manage/simulations/preview/:id" Component={PreviewSimulationPage}></Route>

      <Route path="/simulations/:id" Component={ViewSimulationPage}></Route>

      <Route path="/explore/courses/:courseId" Component={ViewExploreCoursePage}></Route>
      <Route path="/explore/courses/:id/contents" Component={ViewCourseStructurePage}></Route>
      <Route path="/explore/simulations/:id" Component={ViewExploreSimulationPage}></Route>
      <Route path="/explore/podcasts/:id" Component={ViewExplorePodcastPage}></Route>

      <Route path="/manage/podcasts/draft/:id" Component={EditPodcastPage}></Route>
      <Route path="/podcasts/:id" Component={ViewPodcastPage}></Route>

      <Route path="/demo/courses/:courseId" Component={ViewDemoCoursePage}></Route>
      <Route path="/demo/courses/:id/contents" Component={ViewDemoCourseStructurePage}></Route>
      <Route path="/demo/simulations/:id" Component={ViewDemoSimulationPage}></Route>
    </Routes>
  );
};

const CoachingLayoutPage: React.FC<object> = () => {
  const user = useSelector((state: any) => {
    return _.get(state, 'users.me');
  });

  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname

  useEffect(() => {
    if(pathName === "/coaching") {
      navigate('/coaching/explore');
    }
  }, [location]);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <img src="/images/coaching/logo.svg" alt="Coaching" />
          <div className={styles.tabs}>
            <NavLink to={'/coaching/explore'} className={styles.tab}>Explore</NavLink>
            {userRoleService.canCreateCourse() &&
              <NavLink to={'/coaching/studio'} className={styles.tab}>Studio</NavLink>
            }
            <NavLink to={'/coaching/courses'} className={styles.tab}>My Courses</NavLink>
            {userRoleService.canCreateCourse() &&
              <NavLink to={'/coaching/manage'} className={styles.tab}>Manage Courses</NavLink>
            }
            <NavLink to={'/coaching/reports'} className={styles.tab}>Reports</NavLink>
          </div>
          <div className={styles.userProfile}>
            <Thumbnail className={styles.icon} media={user?.icon} />
            <Text
              className={styles.name}
              text={getFullName(user) || ""}
              tooltip={{ placement: "bottom" }}
            />
          </div>
        </div>

        <Outlet />
      </div>
    </>
  );
};

export { CoachingPage };
